// components/WhoItsForSection.jsx
import React from "react";
import "./WhoItsForSection.css";

import PersonRoundedIcon from "@mui/icons-material/PersonRounded";
import RecordVoiceOverRoundedIcon from "@mui/icons-material/RecordVoiceOverRounded";
import EmojiObjectsRoundedIcon from "@mui/icons-material/EmojiObjectsRounded";

function WhoItsForSection() {
  return (
    <section className="who-section" id="who">
      <div className="who-inner">

        {/* Header */}
        <div className="who-header fade-up">
          {/* <p className="who-kicker">Who It's For</p> */}
          <h2 className="who-title">Made for Every Pilgrim</h2>
          <p className="who-subtitle">
            Tawaf is created with elders, first-time travelers, and those who aren’t
            tech-savvy in mind — helping you move confidently through every step
            of your sacred journey.
          </p>
        </div>

        {/* Cards */}
        <div className="who-cards">
          <div className="who-card zoom-in">
            <div className="who-card-icon">
              <PersonRoundedIcon fontSize="medium" />
            </div>
            <h3 className="who-card-title">Simple & Easy to Use</h3>
            <p className="who-card-text">
              Clean screen layouts, large buttons, and clear icons so elders and
              first-time app users feel at ease.
            </p>
          </div>

          <div className="who-card zoom-in delay-1">
            <div className="who-card-icon">
              <RecordVoiceOverRoundedIcon fontSize="medium" />
            </div>
            <h3 className="who-card-title">Voice-First Experience</h3>
            <p className="who-card-text">
              Listen instead of reading. Voice-guided steps and du’as keep your
              focus on worship, not the screen.
            </p>
          </div>

          <div className="who-card zoom-in delay-2">
            <div className="who-card-icon">
              <EmojiObjectsRoundedIcon fontSize="medium" />
            </div>
            <h3 className="who-card-title">A Smart Companion</h3>
            <p className="who-card-text">
              Helpful prompts, safety reminders, and group tracking so you stay
              confident, safe, and connected.
            </p>
          </div>
        </div>

      </div>
    </section>
  );
}

export default WhoItsForSection;
